import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
export const requestPortalTiers = () => noPortalApiClient.get('hub-signup/v2/accounts/portal-tier-info');